import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { DISTRICT_URL } from "@/lib/links";

const StickyBar = () => {
  const [intersecting, setIntersecting] = useState({ "hero-cta": true, "final-cta": false });

  useEffect(() => {
    const targets = ["hero-cta", "final-cta"].map((id) => document.getElementById(id)).filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) =>
        setIntersecting((prev) => {
          const next = { ...prev };
          entries.forEach((e) => (next[e.target.id] = e.isIntersecting));
          return next;
        }),
      { threshold: 0.2 }
    );
    targets.forEach((t) => observer.observe(t));
    return () => observer.disconnect();
  }, []);

  const show = !intersecting["hero-cta"] && !intersecting["final-cta"];

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-ticket-bar"
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "100%" }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50 border-t border-bone/10 bg-night/85 backdrop-blur-xl"
        >
          <div className="mx-auto max-w-5xl px-5 sm:px-10 py-3 flex items-center justify-between gap-4">
            <span className="font-display font-bold text-sm tracking-[0.25em] text-bone">HUGEL</span>
            <a
              data-testid="sticky-district-ticket-button"
              href={DISTRICT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ticket px-7 py-3 text-xs sm:text-sm"
            >
              Get Tickets
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyBar;
